module.exports = __webpack_public_path__ + "static/media/stc-square.6ff14cd5.png";